import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client = sanityClient({
  projectId: 'x6zcf3cm',
  dataset: 'production',
  apiVersion: '2022-02-01',
  useCdn: true,
  token: 'skVqaUU1pBTTLHxeyARydFFvuvSe0byXqR4E0Sm8MQoApjVoZ0XiEOmFQFgdhzVeWp9oi6ysAKDG1yIKQrYUdyOgj0gMmgan5VkEp6R9BxiGAb7R29aGRgGwjp1ccpbkOCCD631fCI5hG76zl1P0UOs8WgBt1qaOvSsXVt4dcLhlYXYmJekJ',
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);